"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Checkout_1 = require("./Checkout");

var VariantRequirement_1 = require("./Requirements/VariantRequirement");

var PoliticalRequirement_1 = require("./Requirements/PoliticalRequirement");

var BillingRequirement_1 = require("./Requirements/BillingRequirement");

var ShippingAddressRequirement_1 = require("./Requirements/ShippingAddressRequirement");

var DonationRequirement_1 = require("./Requirements/DonationRequirement");

var CheckoutFactory =
/** @class */
function () {
  function CheckoutFactory() {}

  CheckoutFactory.prototype.setProduct = function (product) {
    this.product = product;
  };

  CheckoutFactory.prototype.setVideo = function (video) {
    this.video = video;
  };

  CheckoutFactory.prototype.setSavedBillingInfo = function (savedBillingInfo) {
    this.savedBillingInfo = savedBillingInfo;
  };

  CheckoutFactory.prototype.setSavedShippingInfo = function (savedShippingInfo) {
    this.savedShippingInfo = savedShippingInfo;
  };

  CheckoutFactory.prototype.build = function () {
    var checkout = new Checkout_1.default();
    this.assessDonationRequirement(checkout);
    this.assessVariantRequirement(checkout);
    this.assessPoliticalRequirement(checkout);
    this.addBillingRequirement(checkout);
    this.addShippingAddressRequirement(checkout);
    return checkout;
  };

  CheckoutFactory.prototype.addBillingRequirement = function (checkout) {
    checkout.addRequirement(new BillingRequirement_1.default(this.savedBillingInfo));
  };

  CheckoutFactory.prototype.addShippingAddressRequirement = function (checkout) {
    checkout.addRequirement(new ShippingAddressRequirement_1.default(this.savedShippingInfo));
  };

  CheckoutFactory.prototype.assessDonationRequirement = function (checkout) {
    if (this.product && this.product.isDonation) {
      checkout.addRequirement(new DonationRequirement_1.default());
    }
  };

  CheckoutFactory.prototype.assessVariantRequirement = function (checkout) {
    if (this.product && this.product.variants && this.product.variants.length > 0) {
      checkout.addRequirement(new VariantRequirement_1.default(this.product));
    }
  };

  CheckoutFactory.prototype.assessPoliticalRequirement = function (checkout) {
    if (this.product && this.product.categories && this.product.categories.find(function (category) {
      return category.name === "Political";
    })) {
      checkout.addRequirement(new PoliticalRequirement_1.default());
    }
  };

  return CheckoutFactory;
}();

exports.default = CheckoutFactory;